import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Layout
import DashboardLayout from "../admin/src/layout/DashboardLayout";

// Pages
import Dashboard from "../admin/src/pages/Dashboard";
import Users from "../admin/src/pages/Users";
import MySubscriptions from "../admin/src/pages/MySubscriptions";
import Community from "../admin/src/pages/Community";
import Challanges from "../admin/src/pages/Challanges";
import ContentManagement from "../admin/src/pages/ContentManagement";
import FaithStream from "../admin/src/pages/FaithStream";
import Categories from "../admin/src/pages/Categories";
import Settings from "../admin/src/pages/Settings";
import AdminNotificationPage from "../admin/src/pages/AdminNotificationPage";

// ====================================
// Layout Wrapper
// ====================================

const LayoutWrapper = ({ children }) => {
  return (
    <DashboardLayout>
      {children}
    </DashboardLayout>
  );
};

// ====================================
// Admin Protected Route
// ====================================

const ProtectedRoute = ({ children }) => {
  const isAdmin =
    localStorage.getItem("isAdminLogin") === "true";

  // ✅ Block Admin Routes
  if (!isAdmin) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

// ====================================
// Admin Routes
// ====================================

const AdminRoutes = () => {
  return (
    <Routes>
      {/* Dashboard */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <LayoutWrapper>
              <Dashboard />
            </LayoutWrapper>
          </ProtectedRoute>
        }
      />

      {/* Users */}
      <Route
        path="/users"
        element={
          <ProtectedRoute>
            <LayoutWrapper>
              <Users />
            </LayoutWrapper>
          </ProtectedRoute>
        }
      />

      {/* Subscriptions */}
      <Route
        path="/subscriptions"
        element={
          <ProtectedRoute>
            <LayoutWrapper>
              <MySubscriptions />
            </LayoutWrapper>
          </ProtectedRoute>
        }
      />

      {/* Community */}
      <Route
        path="/community"
        element={
          <ProtectedRoute>
            <LayoutWrapper>
              <Community />
            </LayoutWrapper>
          </ProtectedRoute>
        }
      />

      {/* Challenges */}
      <Route
        path="/challenges"
        element={
          <ProtectedRoute>
            <LayoutWrapper>
              <Challanges />
            </LayoutWrapper>
          </ProtectedRoute>
        }
      />

      {/* Content */}
      <Route
        path="/content-management"
        element={
          <ProtectedRoute>
            <LayoutWrapper>
              <ContentManagement />
            </LayoutWrapper>
          </ProtectedRoute>
        }
      />

      {/* Faith Stream */}
      <Route
        path="/faith-stream"
        element={
          <ProtectedRoute>
            <LayoutWrapper>
              <FaithStream />
            </LayoutWrapper>
          </ProtectedRoute>
        }
      />

      {/* Categories */}
      <Route
        path="/categories"
        element={
          <ProtectedRoute>
            <LayoutWrapper>
              <Categories />
            </LayoutWrapper>
          </ProtectedRoute>
        }
      />

      {/* Settings */}
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <LayoutWrapper>
              <Settings />
            </LayoutWrapper>
          </ProtectedRoute>
        }
      />

      <Route
        path="/notifications"
        element={
          <ProtectedRoute>
            <LayoutWrapper>
              <AdminNotificationPage />
            </LayoutWrapper>
          </ProtectedRoute>
        }
      />

      {/* Default */}
      <Route
        path="/"
        element={
          <Navigate
            to="/admin/dashboard"
            replace
          />
        }
      />

      {/* Catch All */}
      <Route
        path="*"
        element={
          <Navigate
            to="/admin/dashboard"
            replace
          />
        }
      />
    </Routes>
  );
};

export default AdminRoutes;